<template>
  <div class="kc-my-show">
    <div v-if="allInBool">
      <div class="drug_wrap" v-for="(item, i) in drugShowList.slice(0, 3)" :key="i">
        <div class="row_wrap">
          <div class="left_text">
            <span v-if="item.index === 0">
              {{ getKeyValueText('drug_use_time', item.useDrugTime) }}
            </span>
            <span
              class="inducer"
              v-if="
                item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
              "
            >
              
            </span>
          </div>
          <div class="right_text">
            <span class="colon">:</span>
            <span class="colon">{{ item.drugName }} </span>
            <span>
              {{
                item.drugSpec +
                ' × ' +
                (templateType === '3' ? item.amount / 1000 : item.amount) +
                ' ' +
                getKeyValueText('package_unit_meng', item.packageUnit)
              }}
            </span>
          </div>
        </div>
        <div class="row_wrap">
          <div class="left_text"></div>
          <div class="right_text right_pad">
            <span class="colon">
              {{
                item.useAuantity +
                ' ' +
                getKeyValueText('measure_unit_meng', item.measureUnit) +
                ' × ' +
                item.useDays +
                '  '
              }}
            </span>
            <span class="colon">
              {{ getKeyValueText('drug_usage_meng_his', item.drugUsage) }}
            </span>
          </div>
        </div>
        <div class="row_wrap" v-if="item.attention">
          <div class="left_text">
            <span>嘱托</span>
          </div>
          <div class="right_text">
            <span class="colon">:</span>
            <span class="colon">{{ item.attention }} </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="drug_wrap" v-for="(item, i) in drugShowList" :key="i">
        <div class="row_wrap">
          <div class="left_text">
            <span v-if="item.index === 0">
              {{ getKeyValueText('drug_use_time', item.useDrugTime) }}
            </span>
            <span
              class="inducer"
              v-if="
                item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
              "
            >
              
            </span>
          </div>
          <div class="right_text">
            <span class="colon">:</span>
            <span class="colon">{{ item.drugName }} </span>
            <span>
              {{
                item.drugSpec +
                ' × ' +
                (templateType === '3' ? item.amount / 1000 : item.amount) +
                ' ' +
                getKeyValueText('package_unit_meng', item.packageUnit)
              }}
            </span>
          </div>
        </div>
        <div class="row_wrap">
          <div class="left_text"></div>
          <div class="right_text right_pad">
            <span class="colon">
              {{
                item.useAuantity +
                ' ' +
                getKeyValueText('measure_unit_meng', item.measureUnit) +
                ' × ' +
                item.useDays +
                '  '
              }}
            </span>
            <span class="colon">
              {{ getKeyValueText('drug_usage_meng_his', item.drugUsage) }}
            </span>
          </div>
        </div>
        <div class="row_wrap" v-if="item.attention">
          <div class="left_text">
            <span>嘱托</span>
          </div>
          <div class="right_text">
            <span class="colon">:</span>
            <span class="colon">{{ item.attention }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  name: 'kcMyShow',
  props: {
    drugList: {
      type: [Array],
      default: () => {
        return []
      }
    },
    allInBool: {
      type: Boolean,
      default: true
    },
    templateType: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      arr: [],
      drugShowList: []
    }
  },
  watch: {
    drugList: {
      handler(val) {
        this.drugShowList = this.handleList(val, 'useDrugTime')
      },
      immediate: true
    },
    allInBool: {
      handler(val) {},
      immediate: true
    },
    templateType: {
      handler(val) {}
    }
  },
  methods: {
    getKeyValueText,
    groupBy(arr, key) {
      let obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        let _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    handleList(val) {
      this.arr = val.filter(item => {
        return item.drugID
      })
      let groupObj = this.groupBy(this.arr, 'useDrugTime')
      let finArr = []
      for (let i in groupObj) {
        finArr.push(groupObj[i])
      }

      finArr = finArr.map((item, i) => {
        item.sort((a, b) => a.isDrugInducer - b.isDrugInducer)
        item.map((item2, index2) => {
          item2.index = index2
          return item2
        })
        return item
      })

      return [].concat(...finArr)
    }
  }
}
</script>

<style lang="scss" scoped>
.drug_wrap {
  width: 100%;
  padding: 0.768rem 0.682667rem 0.682667rem 0.682667rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-bottom: 0.021333rem solid #ececec;
  .row_wrap {
    display: flex;
    margin-bottom: 0.298667rem;
    position: relative;
    .left_text {
      min-width: 1.450667rem;

      .inducer {
        padding-left: 1em;
      }
    }
    .right_text {
      .colon {
        margin-right: 0.298667rem;
      }
      text {
        margin-right: 0.085333rem;
      }
    }
    .right_pad {
      padding-left: 0.64rem;
    }
    .delete_mdrug {
      position: absolute;
      right: 0.213333rem;
      top: 0.213333rem;
      z-index: 999;
      width: 1.024rem;
      height: 1.024rem;
    }

    .drug_name {
      font-size: 0.597333rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      margin-right: 0.426667rem;
    }
    .specification,
    .drug_usage,
    .drug_usage_con,
    .entrust {
      font-size: 0.512rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.704rem;
      margin-right: 0.426667rem;
    }
    .amount {
      font-size: 0.597333rem;
    }
    .price {
      font-size: 0.512rem;
      font-weight: 400;
      color: #f86767;
      line-height: 0.704rem;
    }
    .entrust {
      color: #888;
    }
  }
}
</style>
